"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Client = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7.949 0a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm.39 11.214l1.278-1.194C13.144 10.031 16 12.704 16 16H9.67l-1.332-4.786zm-.6.012L6.481 16H0c0-3.303 2.867-5.98 6.404-5.98h.043l1.292 1.206z",
  className: "fill"
}));
var _default = exports.default = Client;